import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Invoiceview from "../Invoiceview";

function AdminInvoiceView(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={4}
        childrenPage={<Invoiceview/>}/>
        </DataContext.Provider>
    )
}

export default AdminInvoiceView;